import { environment } from "@awread/global/environments";

const productionCloud = 'https://storage.awread.vn/awread-production-bucket';
const devCloud = 'http://192.168.1.25:2103/awread-production-bucket';

export const s3ClientUrl = environment.production ? productionCloud : devCloud;

console.log('environment', environment, 's3ClientUrl', s3ClientUrl);